import { default as _91id_932uNFlNkZFXMeta } from "/app/src/pages/admin/company/[pageType]/[id].vue?macro=true";
import { default as dashboardeAHqfXV7sqMeta } from "/app/src/pages/admin/dashboard.vue?macro=true";
import { default as indexwgywxERjK9Meta } from "/app/src/pages/admin/index.vue?macro=true";
import { default as indexTzotCkrmf9Meta } from "/app/src/pages/dashboard/index.vue?macro=true";
import { default as indexqE7gwJ3BuJMeta } from "/app/src/pages/dashboard/protocol/index.vue?macro=true";
import { default as indexdPwi6hPdMfMeta } from "/app/src/pages/index.vue?macro=true";
import { default as login3hUYZUGxmUMeta } from "/app/src/pages/login.vue?macro=true";
export default [
  {
    name: "admin-company-pageType-id",
    path: "/admin/company/:pageType()/:id()",
    component: () => import("/app/src/pages/admin/company/[pageType]/[id].vue")
  },
  {
    name: "admin-dashboard",
    path: "/admin/dashboard",
    component: () => import("/app/src/pages/admin/dashboard.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: indexwgywxERjK9Meta || {},
    component: () => import("/app/src/pages/admin/index.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    component: () => import("/app/src/pages/dashboard/index.vue")
  },
  {
    name: "dashboard-protocol",
    path: "/dashboard/protocol",
    component: () => import("/app/src/pages/dashboard/protocol/index.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexdPwi6hPdMfMeta || {},
    component: () => import("/app/src/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: login3hUYZUGxmUMeta || {},
    component: () => import("/app/src/pages/login.vue")
  },
  {
    name: indexTzotCkrmf9Meta?.name,
    path: "/dashboard/machine/:id/folder/:uuid",
    meta: {"auth":false},
    component: () => import("/app/src/pages/dashboard/index.vue")
  },
  {
    name: indexqE7gwJ3BuJMeta?.name,
    path: "/dashboard/machine/:id/folder/:uuid/protocol",
    meta: {"auth":false},
    component: () => import("/app/src/pages/dashboard/protocol/index.vue")
  }
]